var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputBox',{staticClass:"dates-input-box",attrs:{"icon":"calendar","label":_vm.label},on:{"click":_vm.clicked}},[_c('template',{slot:"value"},[_c('span',{class:{
      'dates-input-box__start': true,
      'dates-input-box__start--active': (_vm.highlight == 'start' || _vm.highlight == 'date' || _vm.highlight == 'month') },on:{"click":function($event){$event.stopPropagation();return _vm.clicked('start')}}},[_vm._v("\n      "+_vm._s(_vm.start)+"\n    ")]),_vm._v(" "),_c('span',{class:{
      'dates-input-box__end': true,
      'dates-input-box__end--active': _vm.highlight == 'end' },on:{"click":function($event){$event.stopPropagation();return _vm.clicked('end')}}},[_vm._v("\n      "+_vm._s(_vm.end)+"\n    ")])]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e66ba4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DatesInputBox.vue
// module id = 722
// module chunks = 1